import React from 'react';

type DraggableIconProps = {
  className?: string;
  onClick?: () => void;
  size?: number;
  color?: string;
};

const DraggableIcon = ({ size, color = '#4A5374', className, onClick }: DraggableIconProps) => (
  <svg width="19" height="20" viewBox="0 0 10 22" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick}>
    <circle cx="2.14286" cy="2.14286" r="2.14286" fill={color} />
    <circle cx="2.14286" cy="7.8577" r="2.14286" fill={color} />
    <circle cx="2.14286" cy="13.5706" r="2.14286" fill={color} />
    <circle cx="2.14286" cy="19.2854" r="2.14286" fill={color} />
    <circle cx="7.85672" cy="2.14286" r="2.14286" fill={color} />
    <circle cx="7.85672" cy="7.8577" r="2.14286" fill={color} />
    <circle cx="7.85672" cy="13.5706" r="2.14286" fill={color} />
    <circle cx="7.85672" cy="19.2854" r="2.14286" fill={color} />
  </svg>
);


export default DraggableIcon;
